import { GetterTree } from 'vuex';
import { LoaderState } from '@/store/loader/types';
import { RootState } from '@/store/types';

export const getters: GetterTree<LoaderState, RootState> = {
  isLoading: (state) => state.active,
};
